module.exports = __webpack_public_path__ + "components/country-flag/static/la-4a92988be0972760bd31b19a9dd5ce9f.svg";